import { type ValidatorRule } from "rc-field-form/lib/interface"

const MAX_PAYMENT_PERCENTAGE_TOTAL = 100

interface PaymentScheduleRow {
  percentage?: number | string | null
}

function paymentPercentageTotal(items?: PaymentScheduleRow[] | null): number {
  const raw = (items || []).reduce(
    (sum, item) => sum + (Number(item?.percentage) || 0),
    0
  )

  // Percentages are captured to 2dp; round the sum so float drift on values
  // like 33.33 + 33.33 + 33.34 does not read as over 100.
  return Math.round(raw * 100) / 100
}

function paymentScheduleTotalError(total: number): string {
  return `Payment schedule must total 100% or less — currently ${total.toFixed(2)}%.`
}

const validatePaymentScheduleTotal: ValidatorRule["validator"] = (
  _rule,
  value
) => {
  const total = paymentPercentageTotal(value as PaymentScheduleRow[])

  if (total > MAX_PAYMENT_PERCENTAGE_TOTAL) {
    return Promise.reject(new Error(paymentScheduleTotalError(total)))
  }

  return Promise.resolve()
}

export {
  MAX_PAYMENT_PERCENTAGE_TOTAL,
  paymentPercentageTotal,
  paymentScheduleTotalError,
  validatePaymentScheduleTotal
}
